import { Injectable } from '@angular/core';
import { DateFormatHelperService } from './date-format-helper.service';
import { HttpClient } from '@angular/common/http';
import { BaseHttpApiService } from './base-http.service';
import { map, Observable, of } from 'rxjs';
import { ResInstructionsGridDTO } from '../Dtos/res/instructions-grid-dto';
import { ResInstructionDTO, ResIntructionType, ResInstructionSpreadModel, ResContinousMarketData } from '../Dtos/res/instructions-dto';
import { FileAttachmentDTO } from '../Dtos/file-attachment-dto';

@Injectable({
  providedIn: 'root'
})
export class ResService extends BaseHttpApiService {
  constructor(private httpClient: HttpClient,
    private dateHelper: DateFormatHelperService) { super(); }



  GetActiveAndFutureInstructions(): Observable<ResInstructionsGridDTO[]> {
    return this.httpClient.get<ResInstructionsGridDTO[]>(`${this.apiURL}Res/Instructions`);
  }

  GetInstructionsByDateRange(from: Date, to: Date): Observable<ResInstructionsGridDTO[]> {
    return this.httpClient.get<ResInstructionsGridDTO[]>(`${this.apiURL}Res/Instructions/${this.dateHelper.GetAPIFormat(from)}/${this.dateHelper.GetAPIFormat(to)}`);
  }

  GetInstructionById(instructionId: number | string): Observable<ResInstructionDTO> {
    return this.httpClient.get<ResInstructionDTO>(`${this.apiURL}Res/${instructionId}`)
    .pipe(
      map(resp => {
          resp.instructionType = resp.instructionType.toString() == "Auction" ? ResIntructionType.Auction : ResIntructionType.ContinuousMarket;
          resp.spreadModel = resp.spreadModel.toString() == "None" ? ResInstructionSpreadModel.None : ResInstructionSpreadModel.Spread;
          return resp;
      })
    )
  }

  SaveInstruction(instruction: ResInstructionDTO, closeImage: File | null, coAssumptionsImage: File | null) {
    const formData = new FormData();

    // Append data properties to FormData
    if (typeof instruction.issuedFrom === 'string') {
      instruction.issuedFrom = new Date(instruction.issuedFrom);
    }
    instruction.issuedFrom.setUTCHours(0, 0, 0, 0); // Set time to 00:00 GMT
    if (instruction.enforBmus == null)
      instruction.enforBmus = [];
    
    // Append data properties to FormData
    formData.append('issuedFrom', instruction.issuedFrom.toISOString());

    if ((instruction.issuedTo ?? "") != "") {
      if (typeof instruction.issuedTo === 'string') {
        instruction.issuedTo = new Date(instruction.issuedTo);
      }
      // Set time to 23:59
      instruction.issuedTo?.setUTCHours(23, 59, 59, 999);
      formData.append('issuedTo', instruction.issuedTo?.toISOString() ?? "");
    }
    else
      formData.append('issuedTo', instruction.issuedTo?.toString() ?? "");

    formData.append('dateComment', instruction.dateComment ?? "");
    formData.append('summary', instruction.summary ?? "");
    formData.append('spreadModel', ResInstructionSpreadModel[instruction.spreadModel].toString());
    instruction.enforBmus.forEach(item => {
      formData.append('enforBmus', item);
    });
    formData.append('closeNotes', instruction.closeNotes ?? "");
    formData.append('coAssumptionsNotes', instruction.coAssumptionsNotes ?? "");
    formData.append('status', instruction.status ?? "");
    formData.append('isArchived', instruction.isArchived.toString());
    formData.append('instructionType', ResIntructionType[instruction.instructionType].toString());
    // Handle continuous market data
    if (instruction.instructionType == ResIntructionType.ContinuousMarket) {
      formData.append('continuousMarket', JSON.stringify(instruction.continuousMarket));
    } else {
      formData.append('continuousMarket', "[]"); // Append empty array if no data
    }


    // Append files to FormData
    if (closeImage) {
      formData.append('closeImage', closeImage, closeImage.name);
    }
    if (coAssumptionsImage) {
      formData.append('coAssumptionsImage', coAssumptionsImage, coAssumptionsImage.name);
    }

    // Send the request
    let url: string = `${this.apiURL}Res`;
    return this.httpClient.post<object>(url, formData);
  }

  ChangeStatus(instructionId: number | string, status: string) {
    return this.httpClient.put<object>(`${this.apiURL}Res/SetStatus?instructionId=${instructionId}&status=${status}`, '')
  }

  DownloadFile(fileId: number | string): Observable<any> {
    return this.httpClient.get(`${this.apiURL}Res/DownloadFile/${fileId}`, { responseType: 'blob' });
  }

}
